import { ClassVipPassPage } from './ClassVipPassPage';
export default ClassVipPassPage;
